import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import AppLayout from '../components/AppLayout';
import StatusPill from '../components/StatusPill';
import StatusTimeline from '../components/StatusTimeline';
import { useApi } from '../hooks/useApi';
const DashboardPage = () => {
    const { get } = useApi();
    const [services, setServices] = useState([]);
    const [timelines, setTimelines] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [timelineError, setTimelineError] = useState(null);
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        setTimelineError(null);
        try {
            const data = await get('/dashboard');
            setServices(data.services);
        }
        catch (err) {
            setError(err.message);
        }
        try {
            const response = await fetch('/api/public/status');
            if (!response.ok) {
                throw new Error('Failed to load timeline');
            }
            const payload = (await response.json());
            const map = {};
            payload.services.forEach((service) => {
                map[service.id] = service.timeline;
            });
            setTimelines(map);
        }
        catch (err) {
            setTimelineError(err.message);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const unhealthy = useMemo(() => services.filter((service) => service.lastStatus === false), [services]);
    const [activeTab, setActiveTab] = useState('status');
    return (_jsxs(AppLayout, { title: "Dashboard", actions: _jsx("button", { onClick: fetchData, disabled: loading, children: "Refresh" }), children: [error && (_jsx("div", { className: "card", style: { borderColor: 'tomato', color: 'tomato' }, children: error })), timelineError && (_jsx("div", { className: "card", style: { borderColor: 'tomato', color: 'tomato' }, children: timelineError })), _jsxs("div", { className: "tabs", children: [_jsx("button", { className: `tab${activeTab === 'status' ? ' tab--active' : ''}`, type: "button", onClick: () => setActiveTab('status'), children: "Status" }), _jsx("button", { className: `tab${activeTab === 'alerts' ? ' tab--active' : ''}`, type: "button", onClick: () => setActiveTab('alerts'), children: "Recent alerts" })] }), activeTab === 'status' && (_jsx("div", { className: "tab-content", children: _jsxs("div", { className: "card", style: { padding: 0 }, children: [_jsxs("div", { className: "service-row service-row--header", children: [_jsx("span", { children: "Service" }), _jsx("span", { children: "Timeline" }), _jsx("span", { children: "Avg uptime" })] }), services.map((service) => {
                            const url = service.targetUrl ||
                                `${service.serverAddress}${service.endpointPath}`;
                            const timeline = timelines[service.id] || [];
                            const avgUptime = timeline.reduce((acc, entry) => acc + entry.uptimePercent, 0) /
                                timeline.length || 0;
                            return (_jsxs("div", { className: "service-row", children: [_jsxs("div", { className: "service-info", children: [_jsx("h4", { children: service.name }), _jsx("p", { children: url }), _jsx(StatusPill, { online: service.lastStatus ?? undefined })] }), _jsx("div", { className: "service-timeline", children: _jsx(StatusTimeline, { timeline: timeline }) }), _jsxs("div", { className: "service-stats", children: [_jsxs("strong", { children: [avgUptime.toFixed(1), "%"] }), _jsx("span", { children: "Avg last 30d" })] })] }, service.id));
                        })] }) })), activeTab === 'alerts' && (_jsx("div", { className: "tab-content", children: _jsxs("div", { className: "card", children: [_jsx("h3", { style: { marginTop: 0 }, children: "Recent alerts" }), _jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Service" }), _jsx("th", { children: "Status" }), _jsx("th", { children: "Last error" })] }) }), _jsxs("tbody", { children: [unhealthy.map((service) => (_jsxs("tr", { children: [_jsx("td", { children: service.name }), _jsx("td", { children: _jsx(StatusPill, { online: false }) }), _jsx("td", { children: service.lastError || 'Unknown error' })] }, service.id))), !unhealthy.length && (_jsx("tr", { children: _jsx("td", { colSpan: 3, style: { textAlign: 'center', padding: '1rem' }, children: "All services appear healthy." }) }))] })] })] }) }))] }));
};
export default DashboardPage;
